/** @griffel:css-start [d] null **/
.ftrb29c{list-style-type:none;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1jat206{-webkit-padding-start:0;padding-inline-start:0;}
.f22iagw{display:flex;}
.f1vx9l62{flex-direction:column;}
.f1wn3y0l{row-gap:var(--spacingVerticalS);}
.fni485r{flex-wrap:wrap;}
.f122n59{align-items:center;}
.f1869bpl{justify-content:space-between;}
.f1xcgk68{column-gap:var(--spacingHorizontalM);}
.f778t4r{row-gap:var(--spacingVerticalXS);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f9b8bpc{padding-block:var(--spacingVerticalS);}
.f12n3xlw{padding-inline:var(--spacingHorizontalM);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fxugw4r{background-color:var(--colorNeutralBackground1);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.ft85np5{border-radius:var(--borderRadiusMedium);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f1j0q4x9{row-gap:var(--spacingVerticalXXS);}
.fqerorx{flex-grow:1;}
.fb2jqpd{flex-basis:240px;}
.fuzgk9b{min-inline-size:0;}
.fsnqrgy{column-gap:var(--spacingHorizontalS);}
.fjksvth{overflow-wrap:anywhere;}
.fl43uef{font-weight:var(--fontWeightSemibold);}
.f11d4kpn{color:var(--colorNeutralForeground3);}
.fy9rknc{font-size:var(--fontSizeBase200);}
.f6jr5hl{align-items:flex-start;}
.f1ufnopg{column-gap:var(--spacingHorizontalXS);}
.fwrc4pm{line-height:var(--lineHeightBase200);}
.fi64zpg{flex-shrink:0;}
.f7j5a1j{margin-block-start:2px;}
.ffmvakt{color:var(--colorPaletteGreenForeground1);}
.f1hcrxcs{color:var(--colorPaletteRedForeground1);}
.fkfq4zb{color:var(--colorNeutralForeground2);}
/** @griffel:css-end **/